// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      wm-get-directions {
        display: block;
        margin: var(--wm-feature-details-margin);
        ion-button {
          --box-shadow: none;
          --border-radius: 25px;
          ion-icon {
            margin-right: 12px;
          }
        }
      }
      ion-modal {
        --border-radius: 16px;
      }
    `, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/get-directions/get-directions.component.ts"],"names":[],"mappings":";MACM;QACE,cAAc;QACd,wCAAwC;QACxC;UACE,kBAAkB;UAClB,qBAAqB;UACrB;YACE,kBAAkB;UACpB;QACF;MACF;MACA;QACE,qBAAqB;MACvB","sourcesContent":["\n      wm-get-directions {\n        display: block;\n        margin: var(--wm-feature-details-margin);\n        ion-button {\n          --box-shadow: none;\n          --border-radius: 25px;\n          ion-icon {\n            margin-right: 12px;\n          }\n        }\n      }\n      ion-modal {\n        --border-radius: 16px;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
